import { Center, Loader } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { Navigate, useLocation } from "react-router-dom";
import { api } from "../api/client";
import type { ReactNode } from "react";

interface AuthGateProps {
  children: ReactNode;
}

/**
 * Wrapper, который проверяет /api/auth/me перед показом protected-контента.
 *
 * - Идёт запрос → loader на весь экран.
 * - 200 → рендерит children.
 * - 401 (или сетевая ошибка) → редиректит на /login, сохраняя `from` для
 *   возврата после успешного логина (через location.state.from).
 */
export function AuthGate({ children }: AuthGateProps) {
  const location = useLocation();

  const { data, isLoading, error } = useQuery({
    queryKey: ["me"],
    queryFn: () => api.me(),
    retry: false,
    staleTime: 60_000,
  });

  if (isLoading) {
    return (
      <Center mih="100vh">
        <Loader />
      </Center>
    );
  }

  if (error || !data) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
}
